
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimBasketConstituentGrid extends Serenity.EntityGrid<DimBasketConstituentRow, any> {
        protected getColumnsKey() { return DimBasketConstituentColumns.columnsKey; }
        protected getDialogType() { return DimBasketConstituentDialog; }
        protected getIdProperty() { return DimBasketConstituentRow.idProperty; }
        protected getInsertPermission() { return DimBasketConstituentRow.insertPermission; }
        protected getLocalTextPrefix() { return DimBasketConstituentRow.localTextPrefix; }
        protected getService() { return DimBasketConstituentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}